import { Component, Watch,BaseMixins } from '../component';

class FromModalConfig{
    isShow:boolean=false;   /*是否显示模态框*/
    modelTitleL:string;     /*模态框 title多语言key*/
    width:number;           /*Modal的宽度 520*/
    labelWidth:number;      /*标签的宽度 默认150*/
    okText:string;          /*ok text key*/
    cancelText:string;      /*cancel text key*/
    successMsgText:string;  /*成功提示消息文本 */
    okAction:string;        /*ok dispatch type 需要操作数据库时 */
    isHideOk:boolean;       /*不显示OK 按钮*/
    model:any;              /*表单模型 */
}

@Component
export class FormModalMixins extends BaseMixins {
    config:FromModalConfig = new FromModalConfig();

    model:any;

    get record(){ return {}}

    open() {
        this.config.isShow = true;
    }

    close() {
        this.config.isShow = false;
    }

    saveSuccess(value:any){
        this.close();
        this.$emit("save-success",value);
    }

    @Watch("config.isShow")
    showChange(value){
        if(value && Object.keys(this.record).length != 0){
            this.model = this.$util.assign(this.record);
        }
    }
}